<div class="flex-container">
  <div class="step-container">
    <div class="step-text-container">
      <span>Initiate</span>
    </div>
    <div class="step-button-container">
      <button mat-mini-fab (click)="step(1)" class="{{currentStep === 1 ? 'selected-menu' : 'menu-button'}}"> 1</button>
    </div>
  </div>
  <div class="step-container">
    <div class="step-text-container">
      <span>Reporting groups</span>
    </div>
    <div class="step-button-container">
      <button mat-mini-fab (click)="step(2)" class="{{currentStep === 2 ? 'selected-menu' : 'menu-button'}}"> 2</button>
    </div>
  </div>
  <div class="step-container">
    <div class="step-text-container">
      <span>Launch</span>
    </div>
    <div class="step-button-container">
      <button mat-mini-fab (click)="step(3)" class="{{currentStep === 3 ? 'selected-menu' : 'menu-button'}}"> 3</button>
    </div>
  </div>
</div>
